








import { Component, Vue} from 'vue-property-decorator';
import GaragesSearch from '@/components/GaragesSearch.vue';
import HelpContent from '../HelpContent.vue';

@Component({
    components: {
        GaragesSearch,
        HelpContent
    }
})
export default class GaragesSearchPage extends Vue {
    modal_helpProduct: string = "modal-helpProduct";
}
